module.exports = __webpack_public_path__ + "img/sejong_gallery3.f1af586a.jpg";